import { RouterPath } from '@/routes/RouterPath';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { HomeViewType, SettingViewType, HomeTabType } from '@/core/presenter/viewModel';

interface IProps {
  viewType?: HomeViewType;
  settingViewType?: SettingViewType;
  activeTab?: HomeTabType;
  onChangeTabType?: (type: HomeTabType) => void;
  onMoveMainView?: () => void;
  onMoveSettingMainView?: () => void;
  onResetSelectedAsset?: () => void;
  resetSendInfo?: () => void;
}

const FooterBar = ({
  viewType,
  settingViewType,
  activeTab,
  resetSendInfo,
  onChangeTabType,
  onMoveMainView,
  onMoveSettingMainView,
  onResetSelectedAsset,
}: IProps) => {
  const navigate = useNavigate();

  const handleMoveMainView = useCallback(() => {
    if (viewType !== HomeViewType.MAIN) {
      navigate(RouterPath.HOME, { replace: true });
    }

    if (activeTab === HomeTabType.ACTIVITIES && onChangeTabType) {
      onChangeTabType(HomeTabType.ASSETS);
    }

    if (onMoveMainView) onMoveMainView();

    if (onResetSelectedAsset) onResetSelectedAsset();

    if (resetSendInfo) resetSendInfo();
  }, [viewType, activeTab, onChangeTabType, onMoveMainView, onResetSelectedAsset, resetSendInfo, navigate]);

  const handleMoveSettingMainView = useCallback(() => {
    if (settingViewType !== SettingViewType.MAIN) {
      navigate(RouterPath.SETTING, { replace: true });
    }

    if (onMoveSettingMainView) onMoveSettingMainView();
  }, [settingViewType, onMoveSettingMainView, navigate]);

  return (
    <footer>
      <nav>
        <ul>
          <li>
            <a className="pointer_cursor" onClick={handleMoveMainView}>
              <img src="img/BI_circle_footer.png" alt="bi" />
              <p>홈</p>
            </a>
          </li>
          <li>
            <a href="#" className="default_cursor" onClick={(e) => e.preventDefault()}>
              <img src="img/purchase-icon.png" alt="send-icon" className="img_disabled" />
              <p className="text_disabled">구매하기</p>
            </a>
          </li>
          <li>
            <a className="default_cursor" onClick={(e) => e.preventDefault()}>
              <img src="img/purchase-list-icon.png" alt="rcv-icon" className="img_disabled" />
              <p className="text_disabled">구매내역</p>
            </a>
          </li>
          <li>
            <a className="pointer_cursor" onClick={handleMoveSettingMainView}>
              <img src="img/config-icon.png" alt="config-icon" />
              <p>설정</p>
            </a>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default FooterBar;
